import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt, FaArrowUp } from 'react-icons/fa';
import { FiSend } from 'react-icons/fi';
import logo from "../assets/logoImage.webp";
import logo2x from "../assets/logoImage@2x.webp";
import { useSettings } from '../context/SettingsContext';

function Footer() {
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language === 'ar';
  const { settings } = useSettings();
  
  const whatsAppIcon = "M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z";

  const socialMedia = [
    { link: settings.facebook, name: t('footer.social.facebook'), icon: "M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" },
    { link: settings.instagram , name: t('footer.social.instagram'), icon: "M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" },
    { link: settings.linkedin, name: t('footer.social.linkedin'), icon: "M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" },
    ...(settings.whatsappNumbers || []).filter(w => w?.url).map((wa, i) => ({
      link: wa.url,
      name: `${t('footer.social.whatsapp')}${(settings.whatsappNumbers || []).length > 1 ? ` ${i + 1}` : ''}`,
      icon: whatsAppIcon,
    })),
  ].filter(item => item.link);

  const pages = [
    { name: isArabic ? 'الرئيسية' : 'Home', href: "/" },
    { name: isArabic ? 'خدماتنا' : 'Services', href: "/#services" },
    { name: isArabic ? 'أعمالنا' : 'Our Work', href: "/#portfolio" },
    { name: isArabic ? 'من نحن' : 'About Us', href: "/about" },
    { name: isArabic ? 'تواصل معنا' : 'Contact Us', href: "/contact" }
  ];

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="w-full bg-[#0B1120] text-gray-300 relative border-t border-white/5" dir={isArabic ? 'rtl' : 'ltr'}>
      <div className="container mx-auto px-4 lg:px-8 py-16">
        {/* Using a 12-column grid for better proportion control */}
        <div className="grid grid-cols-2 lg:grid-cols-12 gap-8 lg:gap-6">
          
          {/* Column 1: Newsletter (Span 3) */}
          <div className="col-span-2 lg:col-span-3 flex flex-col items-center lg:items-end text-center lg:text-end order-4">
            <h3 className="text-white font-bold text-lg mb-6 text-right w-full">
              {isArabic ? 'اشترك في نشرتنا الإخبارية' : 'Subscribe to our newsletter'}
            </h3>
            <p className="text-sm text-gray-400 mb-6 text-right w-full leading-relaxed">
              {isArabic 
                ? 'احصل على آخر الأخبار والعروض مباشرة على بريدك الإلكتروني' 
                : 'Get the latest news and offers directly to your inbox.'}
            </p>
            <div className="flex w-full gap-2 flex-row-reverse">
              {/* Button */}
              <button className="bg-[#FAA617] text-gray-900 px-5 py-2.5 text-sm font-bold rounded-md hover:bg-yellow-500 transition-colors whitespace-nowrap">
                {isArabic ? 'اشترك الآن' : 'Subscribe Now'}
              </button>
              {/* Input */}
              <div className="flex-1 flex items-center bg-[#151D2F] border border-[#2A344A] rounded-md px-3 gap-2 focus-within:border-gray-500 transition-colors">
                <input 
                  type="email" 
                  placeholder={isArabic ? 'أدخل بريدك الإلكتروني' : 'Enter your email'}
                  className="w-full bg-transparent text-xs text-white placeholder-gray-500 outline-none text-right"
                  dir={isArabic ? 'rtl' : 'ltr'}
                />
                <FiSend className="text-gray-500 shrink-0 text-sm" />
              </div>
            </div>
          </div>

          {/* Column 2: Quick Links (Span 2) */}
          <div className="col-span-1 lg:col-span-2 flex flex-col order-3 lg:border-l border-[#2A344A] lg:pl-6">
            <h3 className="text-white font-bold text-lg mb-6 text-right lg:text-right w-full">
              {isArabic ? 'روابط سريعة' : 'Quick Links'}
            </h3>
            <ul className="space-y-4 text-right w-full">
              {pages.map((page, index) => (
                <li key={index}>
                  <Link
                    to={page.href}
                    className="text-gray-400 hover:text-white transition-colors text-sm"
                  >
                    {page.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 3: Contact Us (Span 3) */}
          <div className="col-span-1 lg:col-span-3 flex flex-col order-2 lg:border-l border-[#2A344A] lg:pl-6">
            <h3 className="text-white font-bold text-lg mb-6 text-right w-full">
              {t('contact.contactUs')}
            </h3>
            <ul className="space-y-4 text-right w-full flex flex-col items-end">
              {(settings.phones || []).filter(Boolean).map((phone, i) => (
                <li key={`phone-${i}`} className="flex items-center gap-3 text-gray-400 text-sm hover:text-white transition-colors">
                  <a href={`tel:${phone}`} dir="ltr">{phone}</a>
                  <FaPhoneAlt className="text-gray-500 shrink-0" />
                </li>
              ))}
              {settings.email && (
                <li className="flex items-center gap-3 text-gray-400 text-sm hover:text-white transition-colors">
                  <a href={`mailto:${settings.email}`} dir="ltr">{settings.email}</a>
                  <FaEnvelope className="text-gray-500 shrink-0" />
                </li>
              )}
              <li className="flex items-center gap-3 text-gray-400 text-sm">
                <span>{isArabic ? 'القاهرة، مصر' : 'Cairo, Egypt'}</span>
                <FaMapMarkerAlt className="text-gray-500 shrink-0" />
              </li>
            </ul>

            {/* Social Media Icons */}
            <div className="flex gap-2 justify-end mt-8 w-full">
              {socialMedia.map((social, index) => (
                <a
                  key={index}
                  href={social.link}
                  className="w-8 h-8 rounded-full border border-[#2A344A] flex items-center justify-center text-gray-400 hover:text-white hover:border-white transition-all duration-300"
                  aria-label={social.name}
                >
                  <svg className="w-3.5 h-3.5 fill-current" viewBox="0 0 24 24">
                    <path d={social.icon} />
                  </svg>
                </a>
              ))}
            </div>
          </div>

          {/* Column 4: Logo & About (Span 4) - Largest Section */}
          <div className="col-span-2 lg:col-span-4 flex flex-col items-center lg:items-end order-1 text-center lg:text-right">
            <div className="h-[170px] !overflow-y-hidden  ">
              <Link to="/" className="inline-block mb-6">
                <img src={logo} srcSet={`${logo} 1x, ${logo2x} 2x`} alt="EMA-X solutions" width="300" height="200" loading="lazy" decoding="async" className="h-50 w-auto" />
              </Link>
            </div>
            <p className="text-gray-400 text-sm leading-loose text-center lg:text-right lg:w-4/5">
              {isArabic 
                ? 'نحن نقدم حلولاً برمجية وتسويقية مبتكرة لمساعدتك على تحقيق أهدافك الرقمية وتنمية أعمالك بنجاح.'
                : 'We provide innovative software and marketing solutions to help you achieve your digital goals and grow your business successfully.'}
            </p>
          </div>

        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-[#2A344A] relative">
        <div className="container mx-auto px-4 py-6 flex items-center justify-center">
          <p className="text-gray-400 text-sm text-center">
            {isArabic ? `جميع الحقوق محفوظة © ${new Date().getFullYear()} ايما اكس` : `All rights reserved © ${new Date().getFullYear()} EMA-X solutions`}
          </p>
          
          {/* Scroll to Top Button */}
          <button 
            onClick={scrollToTop}
            className="absolute left-6 md:left-12 top-1/2 -translate-y-1/2 w-10 h-10 bg-[#0D6EFD] rounded-full flex items-center justify-center text-white hover:bg-blue-600 shadow-[0_0_15px_rgba(13,110,253,0.5)] transition-all duration-300 hover:-translate-y-6"
            aria-label="Scroll to top"
          >
            <FaArrowUp className="text-sm" />
          </button>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
